export default __webpack_public_path__ + "9d13dbf29f84d4133c3e13e90c17bb0d.gif";